/**
 * ARCUS CRM — Service API
 * Wrapper autour de fetch() pour tous les appels backend.
 * Injecte automatiquement le JWT token sur chaque requête.
 */

const BASE = '/api';
const STORAGE_KEY = 'arcus_token';

function getToken() {
  return localStorage.getItem(STORAGE_KEY);
}

async function request(method, path, body) {
  const token = getToken();
  const opts = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${BASE}${path}`, opts);

  // Token expiré → rediriger vers login
  if (res.status === 401) {
    localStorage.removeItem(STORAGE_KEY);
    window.location.href = '/';
    throw new Error('Session expirée');
  }

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `Erreur ${res.status}`);
  }
  return res.json();
}

// ── Authentification ─────────────────────────────────────────────
export const authAPI = {
  login:          (email, password) => request('POST', '/auth/login', { email, password }),
  me:             ()                => request('GET',  '/auth/me'),
  changePassword: (current, next)   => request('POST', '/auth/change-password', {
    current_password: current, new_password: next,
  }),
};

// ── Intermédiaires ───────────────────────────────────────────────
export const intermediairesAPI = {
  list:      (params = {}) => request('GET', `/intermediaires?${new URLSearchParams(params)}`),
  get:       (id)          => request('GET', `/intermediaires/${id}`),
  create:    (data)        => request('POST', '/intermediaires', data),
  update:    (id, data)    => request('PUT',  `/intermediaires/${id}`, data),
  setStatut: (id, statut)  => request('PATCH',`/intermediaires/${id}/statut`, { statut }),
  delete:    (id)          => request('DELETE',`/intermediaires/${id}`),
};

// ── Clients ──────────────────────────────────────────────────────
export const clientsAPI = {
  list:   (params = {}) => request('GET',    `/clients?${new URLSearchParams(params)}`),
  get:    (id)          => request('GET',    `/clients/${id}`),
  create: (data)        => request('POST',   '/clients', data),
  update: (id, data)    => request('PUT',    `/clients/${id}`, data),
  delete: (id)          => request('DELETE', `/clients/${id}`),
};

// ── Polices ──────────────────────────────────────────────────────
export const policesAPI = {
  list:     (params = {}) => request('GET',    `/polices?${new URLSearchParams(params)}`),
  get:      (id)          => request('GET',    `/polices/${id}`),
  create:   (data)        => request('POST',   '/polices', data),
  update:   (id, data)    => request('PUT',    `/polices/${id}`, data),
  calculer: (id, data)    => request('POST',   `/polices/${id}/calculer`, data),
  delete:   (id)          => request('DELETE', `/polices/${id}`),
};

// ── Documents ────────────────────────────────────────────────────
export const documentsAPI = {
  download: (policeId, type) => {
    const token = getToken();
    // Ouvrir avec token dans l'URL n'est pas idéal mais fonctionnel pour les downloads
    window.open(`${BASE}/documents/${policeId}/${type}?token=${token}`, '_blank');
  },
};
